/** Manifest dates use YYYY-MM or YYYY-MM-DD. */

export function formatManifestDate(value: string): string {
  const monthOnly = /^(\d{4})-(\d{2})$/.exec(value)
  if (monthOnly) {
    const year = Number(monthOnly[1])
    const month = Number(monthOnly[2]) - 1
    return new Date(year, month, 1).toLocaleDateString('en-US', {
      month: 'long',
      year: 'numeric'
    })
  }

  const full = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value)
  if (full) {
    const year = Number(full[1])
    const month = Number(full[2]) - 1
    const day = Number(full[3])
    return new Date(year, month, day).toLocaleDateString('en-US', {
      month: 'long',
      day: 'numeric',
      year: 'numeric'
    })
  }

  return value
}

/** Human-readable range for cards and project headers. */
export function formatProjectDateRange(
  startDate?: string,
  endDate?: string
): string | undefined {
  if (!startDate && !endDate) return undefined
  if (startDate && endDate && startDate === endDate) {
    return formatManifestDate(endDate)
  }
  if (startDate && endDate) {
    return `${formatManifestDate(startDate)} – ${formatManifestDate(endDate)}`
  }
  if (endDate) return formatManifestDate(endDate)
  return `${formatManifestDate(startDate!)} – present`
}

/** Sort key: prefer end date, then start (newer first). */
export function projectDateSortKey(startDate?: string, endDate?: string): number {
  const key = endDate ?? startDate
  if (!key) return 0
  const monthOnly = /^(\d{4})-(\d{2})$/.exec(key)
  if (monthOnly) return Number(`${monthOnly[1]}${monthOnly[2]}31`)
  const full = /^(\d{4})-(\d{2})-(\d{2})$/.exec(key)
  if (full) return Number(`${full[1]}${full[2]}${full[3]}`)
  return 0
}
